/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GradoCountDto } from '../../models/grado-count-dto';

export interface ApiOrganicoGradoListGet$Params {
    /**
     * Indica se contare anche i vigili appartenenti al grado (Default true)
     */
    countVigili?: boolean;

    /**
     * Id dell'unione per cui caricare i volontari
     */
    unioneId?: number;

    /**
     * Id del corpo per cui caricare i volontari
     */
    corpoId?: number;
}

export function apiOrganicoGradoListGet(
    http: HttpClient,
    rootUrl: string,
    params?: ApiOrganicoGradoListGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<Array<GradoCountDto>>> {
    const rb = new RequestBuilder(rootUrl, apiOrganicoGradoListGet.PATH, 'get');
    if (params) {
        rb.query('countVigili', params.countVigili, {});
        rb.query('unioneId', params.unioneId, {});
        rb.query('corpoId', params.corpoId, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Array<GradoCountDto>>;
        }),
    );
}

apiOrganicoGradoListGet.PATH = '/api/organico/grado-list';
